import * as actions from "Actions";
import * as api from "Api";
import { pushSourceToken } from "Utils";

export const fetchWebtools = ({ limit = 30, offset = 0 }) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_WEBTOOLS", dispatch);

    const { lng } = getState().params;
    const { filter } = getState().webtools;
    const { auth } = getState();
    const { token, navCommunity } = auth;

    return dispatch(
      actions.fetchWebtools(
        api
          .getWebtools({
            token,
            limit,
            offset,
            lng,
            filter,
            communityId: navCommunity.id,
            sourceToken
          })
          .then(resp => {
            setTimeout(() => {
              const { items } = getState().webtools.favorites;
              dispatch(actions.reduceWebtools(items));
            }, 100);
            return resp;
          })
      )
    );
  };
};

export const fetchWebtoolsFavorites = ({ limit = 30, offset = 0 }) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_WEBTOOLS_FAVORITES", dispatch);

    const { auth, params } = getState();
    const { filter } = getState().webtools;

    const { token, navCommunity } = auth;

    return dispatch(
      actions.fetchWebtoolsFavorites(
        api.getWebtoolsFavorites({
          token,
          limit,
          offset,
          filter,
          language: params.lng,
          community: navCommunity.id,
          sourceToken
        })
      )
    );
  };
};

export const fetchWebtoolsCategories = () => (dispatch, getState) => {
  const { token } = getState().auth;

  if (token === "") {
    return null;
  }
  return dispatch(
    actions.fetchWebtoolsCategories(
      api.getWebtoolsCategories({
        token
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/webtool.js